import React, { useEffect, useState, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { SheetMusicCard, SheetMusicItem } from './SheetMusicCard';
import { SheetMusicPreviewModal } from './SheetMusicPreviewModal';
import { SheetMusicFilters } from './SheetMusicFilters';
import { MusicIcon, FileTextIcon, BookOpenIcon, ChevronDownIcon } from 'lucide-react';
// Demo data for sheet music
const demoSheetMusic: SheetMusicItem[] = [{
  id: '1',
  title: 'Moonlight Sonata',
  composer: 'Ludwig van Beethoven',
  instruments: ['Piano'],
  era: 'Classical',
  difficulty: 'Intermediate',
  tags: ['Sonata', 'Famous', 'Romantic'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BeethovenLv/O27/moonlight/moonlight-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/2HwrMfKeXJ8k7ahFWjVNJK/IMG_4446.jpg'
}, {
  id: '5',
  title: 'Prelude in C Major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano', 'Harpsichord'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Well-Tempered Clavier', 'Prelude', 'Counterpoint'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV846/wtk1-prelude1/wtk1-prelude1-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/7oUwphpLRiC5PZuGw98eyU/IMG_4447.jpg'
}, {
  id: '6',
  title: 'Toccatina',
  composer: 'Charles-Valentin Alkan',
  instruments: ['Piano'],
  era: 'Romantic',
  difficulty: 'Advanced',
  tags: ['Toccata', 'Virtuosic', 'Brilliant'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/AlkanCV/O75/toccatina/toccatina-let.pdf',
  thumbnailUrl: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400&h=300&fit=crop'
}, {
  id: '9',
  title: 'Rondo in E-flat Major',
  composer: 'Carl Philipp Emanuel Bach',
  instruments: ['Harpsichord', 'Piano'],
  era: 'Classical',
  difficulty: 'Intermediate',
  tags: ['Rondo', 'Galant Style', 'Empfindsamer Stil'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachCPE/cpe-bach-rondo/cpe-bach-rondo-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/cqaH4pUUQqBscnfRgAcGfJ/IMG_4464.jpg'
}, {
  id: '10',
  title: 'Polonaise in F Major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Harpsichord', 'Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Polonaise', 'Anna Magdalena Notebook', 'Dance'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV117a/BWV-117a/BWV-117a-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/uqd61qJjLTsJKojhUQvXvf/IMG_4466.jpg'
}, {
  id: '11',
  title: 'Aus meines Herzens Grunde',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 269', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV269/bwv_269/bwv_269-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/1LZ2PSutPMums6iuzUyv8E/IMG_4467.jpg'
}, {
  id: '12',
  title: 'Ich dank dir, lieber Herre',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 347', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV347/bwv347/bwv347-let.pdf',
  thumbnailUrl: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400&h=300&fit=crop'
}, {
  id: '13',
  title: 'Ermuntere dich, mein schwacher Geist',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 454', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV454/bwv_454/bwv_454-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/cacj22qrocWj2wmN2Ru9Pi/IMG_4468.jpg'
}, {
  id: '14',
  title: 'Gott, wie gross ist deine Güte',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 462', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV462/bwv_462/bwv_462-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/gjmc4KaQzYMDZuvfKxZfUw/IMG_4469.jpg'
}, {
  id: '15',
  title: 'Gib dich zufrieden und sei stille',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 460', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV460/bwv_460/bwv_460-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/fcH6KVfLbrxVBAhkHK7noD/IMG_4470.jpg'
}, {
  id: '16',
  title: 'Gib dich zufrieden und sei stille (D minor)',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Chorale', 'BWV 461', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV461/bwv_461/bwv_461-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/v9wknLFnK292pfg9ZBX787/IMG_4476.jpg'
}, {
  id: '17',
  title: 'Aria',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Aria', 'BWV 515', 'Anna Magdalena Notebook'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV515/anna-magdalena-20a/anna-magdalena-20a-let.pdf',
  thumbnailUrl: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400&h=300&fit=crop'
}, {
  id: '18',
  title: 'Warum betrübst du dich',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Beginner',
  tags: ['Aria', 'BWV 516', 'Sacred'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV516/BWV-516/BWV-516-let.pdf',
  thumbnailUrl: 'https://images.unsplash.com/photo-1514119412350-e174d90d280e?w=400&h=300&fit=crop'
}, {
  id: '19',
  title: 'Invention No. 2 in C minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 773', 'Counterpoint', 'C minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV773/bach-invention-02/bach-invention-02-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/um9jFEnf4LjTiojaZGNuvA/IMG_4480.jpg'
}, {
  id: '20',
  title: 'Invention No. 3 in D major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 774', 'Counterpoint', 'D major'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV774/bach-invention-03/bach-invention-03-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/d6qahaEKBbSwyaGToBWwEZ/IMG_4481.jpg'
}, {
  id: '21',
  title: 'Invention No. 4 in D minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 775', 'Counterpoint', 'D minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV775/bach-invention-04/bach-invention-04-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/v9wknLFnK292pfg9ZBX787/IMG_4476.jpg'
}, {
  id: '22',
  title: 'Invention No. 5 in E-flat major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 776', 'Counterpoint', 'E-flat major'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV776/bach-invention-05/bach-invention-05-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/bAWMazQ4ptjUtszadevdAc/IMG_4484.jpg'
}, {
  id: '23',
  title: 'Invention No. 7 in E minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 778', 'Counterpoint', 'E minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV778/bach-invention-07/bach-invention-07-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/36Tqg13AZrCt5B3njz867j/IMG_4607.jpg'
}, {
  id: '24',
  title: 'Invention No. 8 in F major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 779', 'Counterpoint', 'F major'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV779/bach-invention-08/bach-invention-08-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/aCLF3bzLKvZbuMcBwkGYDS/IMG_4608.jpg'
}, {
  id: '25',
  title: 'Invention No. 10 in G major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 781', 'Counterpoint', 'G major'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV781/bach-invention-10/bach-invention-10-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/efayjDmjhsbzPPjwj7QrKB/IMG_4478.jpg'
}, {
  id: '26',
  title: 'Invention No. 11 in G minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 782', 'Counterpoint', 'G minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV782/bach-invention-11/bach-invention-11-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/1wLiiMZ6a9Qt9VVviFxF64/IMG_4609.jpg'
}, {
  id: '27',
  title: 'Invention No. 13 in A minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 784', 'Counterpoint', 'A minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV784/bach-invention-13/bach-invention-13-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/um9jFEnf4LjTiojaZGNuvA/IMG_4480.jpg'
}, {
  id: '28',
  title: 'Invention No. 14 in B-flat major',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 785', 'Counterpoint', 'B-flat major'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV785/bach-invention-14/bach-invention-14-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/4tScR9wg7buBPmh17TFXUK/IMG_4610.jpg'
}, {
  id: '29',
  title: 'Invention No. 15 in B minor',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Invention', 'BWV 786', 'Counterpoint', 'B minor'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV786/bach-invention-15/bach-invention-15-let.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/d6qahaEKBbSwyaGToBWwEZ/IMG_4481.jpg'
}, {
  id: '30',
  title: 'English Suite No. 1 – Bourrée I',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['English Suite', 'BWV 806', 'Bourrée', 'Dance'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV806/bach-english-suite-1-bourree-1/bach-english-suite-1-bourree-1-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/um9jFEnf4LjTiojaZGNuvA/IMG_4480.jpg'
}, {
  id: '31',
  title: 'English Suite No. 1 – Bourrée II',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['English Suite', 'BWV 806', 'Bourrée', 'Dance'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV806/bach-english-suite-1-bourree-2/bach-english-suite-1-bourree-2-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/d6qahaEKBbSwyaGToBWwEZ/IMG_4481.jpg'
}, {
  id: '32',
  title: 'English Suite No. 2 – Bourrée I',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['English Suite', 'BWV 807', 'Bourrée', 'Dance'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV807/bach-english-suite-2-bourree-1/bach-english-suite-2-bourree-1-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/bAWMazQ4ptjUtszadevdAc/IMG_4484.jpg'
}, {
  id: '33',
  title: 'English Suite No. 2 – Bourrée II',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['English Suite', 'BWV 807', 'Bourrée', 'Dance'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV807/bach-english-suite-2-bourree-2/bach-english-suite-2-bourree-2-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/efayjDmjhsbzPPjwj7QrKB/IMG_4478.jpg'
}, {
  id: '34',
  title: 'WTC I – Fugue No. 1 in C Major, BWV 846',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Well-Tempered Clavier', 'BWV 846', 'Fugue', 'Counterpoint'],
  pdfUrl: 'https://firebasestorage.googleapis.com/v0/b/maestro-connect-2e3f0.firebasestorage.app/o/sheet-music%2Fbach%2Fwtk1-fugue1-a4.pdf?alt=media&token=4ef8352f-4b1f-46a6-a03d-dbc2d36167c5',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/7oUwphpLRiC5PZuGw98eyU/IMG_4447.jpg'
}, {
  id: '35',
  title: 'WTC I – Prelude No. 2 in C Minor, BWV 847',
  composer: 'Johann Sebastian Bach',
  instruments: ['Piano'],
  era: 'Baroque',
  difficulty: 'Intermediate',
  tags: ['Well-Tempered Clavier', 'BWV 847', 'Prelude', 'Counterpoint'],
  pdfUrl: 'https://www.mutopiaproject.org/ftp/BachJS/BWV847/bwv847a/bwv847a-a4.pdf',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/v9wknLFnK292pfg9ZBX787/IMG_4476.jpg'
}];
// Get unique values for filter options
const getUniqueInstruments = (items: SheetMusicItem[]): string[] => {
  const allInstruments = items.flatMap(item => item.instruments);
  return Array.from(new Set(allInstruments)).sort();
};
const getUniqueEras = (items: SheetMusicItem[]): string[] => {
  return Array.from(new Set(items.map(item => item.era))).sort();
};
const getUniqueDifficulties = (items: SheetMusicItem[]): string[] => {
  return Array.from(new Set(items.map(item => item.difficulty))).sort();
};
interface SheetMusicLibraryProps {
  darkMode: boolean;
}
export const SheetMusicLibrary: React.FC<SheetMusicLibraryProps> = ({
  darkMode
}) => {
  const navigate = useNavigate();
  // State for sheet music data
  const [sheetMusicItems, setSheetMusicItems] = useState<SheetMusicItem[]>(demoSheetMusic);
  const [filteredItems, setFilteredItems] = useState<SheetMusicItem[]>(demoSheetMusic);
  // State for selected filters
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedInstruments, setSelectedInstruments] = useState<string[]>([]);
  const [selectedEras, setSelectedEras] = useState<string[]>([]);
  const [selectedDifficulties, setSelectedDifficulties] = useState<string[]>([]);
  // State for preview modal
  const [previewItem, setPreviewItem] = useState<SheetMusicItem | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  // Generate filter options
  const filterOptions = {
    instruments: getUniqueInstruments(sheetMusicItems),
    eras: getUniqueEras(sheetMusicItems),
    difficulties: getUniqueDifficulties(sheetMusicItems)
  };
  // Handle view sheet music
  const handleViewSheetMusic = (item: SheetMusicItem) => {
    // Special handling for Moonlight Sonata - navigate to dedicated viewer
    if (item.id === '1' || item.title === 'Moonlight Sonata') {
      navigate('/sheet-music/moonlight-sonata');
      return;
    }
    // Special handling for Prelude in C Major - navigate to dedicated viewer
    if (item.id === '5' || item.title === 'Prelude in C Major') {
      navigate('/sheet-music/prelude-in-c-major');
      return;
    }
    // Special handling for Toccatina - navigate to dedicated viewer
    if (item.id === '6' || item.title === 'Toccatina') {
      navigate('/sheet-music/toccatina');
      return;
    }
    // Special handling for Rondo in E-flat Major - navigate to dedicated viewer
    if (item.id === '9' || item.title === 'Rondo in E-flat Major') {
      navigate('/sheet-music/rondo-in-e-flat');
      return;
    }
    // Special handling for Polonaise in F Major - navigate to dedicated viewer
    if (item.id === '10' || item.title === 'Polonaise in F Major') {
      navigate('/sheet-music/polonaise-in-f');
      return;
    }
    // Special handling for Aus meines Herzens Grunde - navigate to dedicated viewer
    if (item.id === '11' || item.title === 'Aus meines Herzens Grunde') {
      navigate('/sheet-music/aus-meines-herzens-grunde');
      return;
    }
    // Special handling for Ich dank dir, lieber Herre - navigate to dedicated viewer
    if (item.id === '12' || item.title === 'Ich dank dir, lieber Herre') {
      navigate('/sheet-music/ich-dank-dir-lieber-herre');
      return;
    }
    // Special handling for Ermuntere dich, mein schwacher Geist - navigate to dedicated viewer
    if (item.id === '13' || item.title === 'Ermuntere dich, mein schwacher Geist') {
      navigate('/sheet-music/ermuntere-dich-mein-schwacher-geist');
      return;
    }
    // Special handling for Gott, wie gross ist deine Güte - navigate to dedicated viewer
    if (item.id === '14' || item.title === 'Gott, wie gross ist deine Güte') {
      navigate('/sheet-music/gott-wie-gross-ist-deine-gute');
      return;
    }
    // Special handling for Gib dich zufrieden und sei stille - navigate to dedicated viewer
    if (item.id === '15' || item.title === 'Gib dich zufrieden und sei stille') {
      navigate('/sheet-music/gib-dich-zufrieden-und-sei-stille');
      return;
    }
    // Special handling for Gib dich zufrieden und sei stille (D minor) - navigate to dedicated viewer
    if (item.id === '16' || item.title === 'Gib dich zufrieden und sei stille (D minor)') {
      navigate('/sheet-music/gib-dich-zufrieden-und-sei-stille-d-minor');
      return;
    }
    // Special handling for Aria BWV 515 - navigate to dedicated viewer
    if (item.id === '17' || item.title === 'Aria') {
      navigate('/sheet-music/aria-bwv-515');
      return;
    }
    // Special handling for Warum betrübst du dich BWV 516 - navigate to dedicated viewer
    if (item.id === '18' || item.title === 'Warum betrübst du dich') {
      navigate('/sheet-music/warum-betrubst-du-dich');
      return;
    }
    // Special handling for Invention No. 2 BWV 773 - navigate to dedicated viewer
    if (item.id === '19' || item.title === 'Invention No. 2 in C minor') {
      navigate('/sheet-music/invention-no-2');
      return;
    }
    // Special handling for Invention No. 3 BWV 774 - navigate to dedicated viewer
    if (item.id === '20' || item.title === 'Invention No. 3 in D major') {
      navigate('/sheet-music/invention-no-3');
      return;
    }
    // Special handling for Invention No. 4 BWV 775 - navigate to dedicated viewer
    if (item.id === '21' || item.title === 'Invention No. 4 in D minor') {
      navigate('/sheet-music/invention-no-4');
      return;
    }
    // Special handling for Invention No. 5 BWV 776 - navigate to dedicated viewer
    if (item.id === '22' || item.title === 'Invention No. 5 in E-flat major') {
      navigate('/sheet-music/invention-no-5');
      return;
    }
    // Special handling for Invention No. 7 BWV 778 - navigate to dedicated viewer
    if (item.id === '23' || item.title === 'Invention No. 7 in E minor') {
      navigate('/sheet-music/invention-no-7');
      return;
    }
    // Special handling for Invention No. 8 BWV 779 - navigate to dedicated viewer
    if (item.id === '24' || item.title === 'Invention No. 8 in F major') {
      navigate('/sheet-music/invention-no-8');
      return;
    }
    // Special handling for Invention No. 10 BWV 781 - navigate to dedicated viewer
    if (item.id === '25' || item.title === 'Invention No. 10 in G major') {
      navigate('/sheet-music/invention-no-10');
      return;
    }
    // Special handling for Invention No. 11 BWV 782 - navigate to dedicated viewer
    if (item.id === '26' || item.title === 'Invention No. 11 in G minor') {
      navigate('/sheet-music/invention-no-11');
      return;
    }
    // Special handling for Invention No. 13 BWV 784 - navigate to dedicated viewer
    if (item.id === '27' || item.title === 'Invention No. 13 in A minor') {
      navigate('/sheet-music/invention-no-13');
      return;
    }
    // Special handling for Invention No. 14 BWV 785 - navigate to dedicated viewer
    if (item.id === '28' || item.title === 'Invention No. 14 in B-flat major') {
      navigate('/sheet-music/invention-no-14');
      return;
    }
    // Special handling for Invention No. 15 BWV 786 - navigate to dedicated viewer
    if (item.id === '29' || item.title === 'Invention No. 15 in B minor') {
      navigate('/sheet-music/invention-no-15');
      return;
    }
    // English Suite No. 1 – Bourrée I
    if (item.id === '30' || item.title === 'English Suite No. 1 – Bourrée I') {
      navigate('/sheet-music/english-suite-1-bourree-1');
      return;
    }
    // English Suite No. 1 – Bourrée II
    if (item.id === '31' || item.title === 'English Suite No. 1 – Bourrée II') {
      navigate('/sheet-music/english-suite-1-bourree-2');
      return;
    }
    // English Suite No. 2 – Bourrée I
    if (item.id === '32' || item.title === 'English Suite No. 2 – Bourrée I') {
      navigate('/sheet-music/english-suite-2-bourree-1');
      return;
    }
    // English Suite No. 2 – Bourrée II
    if (item.id === '33' || item.title === 'English Suite No. 2 – Bourrée II') {
      navigate('/sheet-music/english-suite-2-bourree-2');
      return;
    }
    // Fugue in C Major BWV 846
    if (item.id === '34' || item.title === 'WTC I – Fugue No. 1 in C Major, BWV 846') {
      navigate('/sheet-music/wtk1-fugue-c-major');
      return;
    }
    // Prelude in C Minor BWV 847
    if (item.id === '35' || item.title === 'WTC I – Prelude No. 2 in C Minor, BWV 847') {
      navigate('/sheet-music/wtk1-prelude-c-minor');
      return;
    }
    // For all other pieces, navigate to generic viewer with item data
    navigate(`/sheet-music/view/${item.id}`, {
      state: {
        item
      }
    });
  };
  // Handle download sheet music
  const handleDownloadSheetMusic = (item: SheetMusicItem) => {
    // Create a temporary anchor element to trigger download
    const resolvedUrl = item.firebaseUrl ?? item.pdfUrl;
    const link = document.createElement('a');
    link.href = resolvedUrl;
    link.download = `${item.composer} - ${item.title}.pdf`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Handle toggle favorite
  const handleToggleFavorite = (id: string, isFavorite: boolean) => {
    // Update local state
    setSheetMusicItems(prevItems => prevItems.map(item => item.id === id ? {
      ...item,
      isFavorite
    } : item));
  };
  // Apply filters when any filter changes
  useEffect(() => {
    let results = [...sheetMusicItems];
    // Apply search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      results = results.filter(item => item.title.toLowerCase().includes(query) || item.composer.toLowerCase().includes(query));
    }
    // Apply instrument filter
    if (selectedInstruments.length > 0) {
      results = results.filter(item => item.instruments.some(instrument => selectedInstruments.includes(instrument)));
    }
    // Apply era filter
    if (selectedEras.length > 0) {
      results = results.filter(item => selectedEras.includes(item.era));
    }
    // Apply difficulty filter
    if (selectedDifficulties.length > 0) {
      results = results.filter(item => selectedDifficulties.includes(item.difficulty));
    }
    setFilteredItems(results);
    setCurrentPage(1); // Reset to first page when filters change
  }, [searchQuery, selectedInstruments, selectedEras, selectedDifficulties, sheetMusicItems]);
  // Get current page items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  // Calculate total pages
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      // Scroll to top of results
      window.scrollTo({
        top: document.getElementById('sheet-music-results')?.offsetTop || 0,
        behavior: 'smooth'
      });
    }
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      // Scroll to top of results
      window.scrollTo({
        top: document.getElementById('sheet-music-results')?.offsetTop || 0,
        behavior: 'smooth'
      });
    }
  };
  return <div data-id="element-10960">
      <div className="mb-6" data-id="element-10961">
        <p className={`mt-1 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10962">
          Browse and download sheet music for your practice
        </p>
      </div>

      {/* Filters */}
      <SheetMusicFilters darkMode={darkMode} onSearchChange={setSearchQuery} onInstrumentChange={setSelectedInstruments} onEraChange={setSelectedEras} onDifficultyChange={setSelectedDifficulties} filterOptions={filterOptions} selectedInstruments={selectedInstruments} selectedEras={selectedEras} selectedDifficulties={selectedDifficulties} data-id="element-10963" />

      {/* Results Count */}
      <div id="sheet-music-results" className={`mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10964">
        {filteredItems.length === 0 ? 'No sheet music found matching your filters' : `Showing ${indexOfFirstItem + 1}-${Math.min(indexOfLastItem, filteredItems.length)} of ${filteredItems.length} ${filteredItems.length === 1 ? 'item' : 'items'}`}
      </div>

      {/* Sheet Music Grid */}
      {currentItems.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-10965">
          {currentItems.map(item => <SheetMusicCard key={item.id} item={item} darkMode={darkMode} onView={handleViewSheetMusic} onDownload={handleDownloadSheetMusic} onToggleFavorite={handleToggleFavorite} data-id="element-10966" />)}
        </div> : <div className={`text-center py-16 ${darkMode ? 'bg-navy-800/50' : 'bg-gray-50'} rounded-xl`} data-id="element-10967">
          <FileTextIcon className={`h-16 w-16 mx-auto ${darkMode ? 'text-gray-600' : 'text-gray-400'}`} data-id="element-10968" />
          <h3 className={`mt-4 text-lg font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-10969">
            No sheet music found
          </h3>
          <p className={`mt-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'} max-w-md mx-auto`} data-id="element-10970">
            Try adjusting your filters or search for different terms.
          </p>
          <button onClick={() => {
        setSearchQuery('');
        setSelectedInstruments([]);
        setSelectedEras([]);
        setSelectedDifficulties([]);
      }} className="mt-4 bg-deep-pink hover:bg-burgundy text-white px-4 py-2 rounded-lg transition-colors" data-id="element-10971">
            Reset Filters
          </button>
        </div>}

      {/* Pagination Controls */}
      {filteredItems.length > 0 && totalPages > 1 && <div className="mt-8 flex justify-between items-center" data-id="element-10972">
          <button onClick={handlePrevPage} disabled={currentPage === 1} className={`px-4 py-2 rounded-lg ${currentPage === 1 ? darkMode ? 'bg-navy-900/30 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed' : darkMode ? 'bg-navy-900/50 text-white hover:bg-navy-800' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'} transition-colors`} data-id="element-10973">
            Previous
          </button>
          <div className={darkMode ? 'text-gray-300' : 'text-gray-600'} data-id="element-10974">
            Page {currentPage} of {totalPages}
          </div>
          <button onClick={handleNextPage} disabled={currentPage === totalPages} className={`px-4 py-2 rounded-lg ${currentPage === totalPages ? darkMode ? 'bg-navy-900/30 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed' : darkMode ? 'bg-navy-900/50 text-white hover:bg-navy-800' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'} transition-colors`} data-id="element-10975">
            Next
          </button>
        </div>}

      {/* Load More Button (Alternative to pagination) */}
      {filteredItems.length > indexOfLastItem && <div className="mt-8 text-center" data-id="element-10976">
          <button onClick={handleNextPage} className={`inline-flex items-center px-6 py-3 rounded-lg ${darkMode ? 'bg-navy-900/50 text-white hover:bg-navy-800' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'} transition-colors`} data-id="element-10977">
            Load More
            <ChevronDownIcon className="ml-2 h-5 w-5" data-id="element-10978" />
          </button>
        </div>}

      {/* Preview Modal */}
      {previewItem && <SheetMusicPreviewModal isOpen={isPreviewOpen} onClose={() => setIsPreviewOpen(false)} item={previewItem} darkMode={darkMode} onDownload={handleDownloadSheetMusic} onToggleFavorite={handleToggleFavorite} data-id="element-10979" />}
    </div>;
};